import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Header = () => {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const isActive = (path) => location.pathname === path;

  // Check if user is admin
  const isAdmin = user?.is_admin || user?.plan === 'admin' || 
    ['jorge.daza@gmail.com', 'verayerka239@gmail.com', 'jorge.daza039@gmail.com'].includes(user?.email);

  return (
    <header className="sticky top-0 z-50 bg-white/95 dark:bg-background-dark/95 backdrop-blur-sm border-b border-gray-100 dark:border-[#283039]">
      <div className="flex items-center justify-between h-16 px-4 sm:px-6">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 text-gray-900 dark:text-white">
          <div className="w-10 h-10 flex-shrink-0">
            <img src="/branding/gpt-jdp-logo.png" alt="GPT-JDP Logo" className="w-full h-full object-contain" />
          </div>
          <span className="text-xl font-bold tracking-tight">GPT-JDP</span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-1">
          {isAuthenticated ? (
            <>
              {/* Herramientas */}
              <Link 
                to="/dashboard" 
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive('/dashboard') 
                    ? 'bg-primary/10 text-primary' 
                    : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#283039]'
                }`}
              >
                Dashboard
              </Link>
              
              <Link 
                to="/generate" 
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive('/generate') 
                    ? 'bg-primary/10 text-primary' 
                    : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#283039]'
                }`}
              >
                Generar
              </Link>

              {/* Asistentes / Chat */}
              <div className="h-6 w-px bg-gray-200 dark:bg-[#283039] mx-2"></div>
              
              <Link 
                to="/chat" 
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive('/chat') 
                    ? 'bg-primary/10 text-primary' 
                    : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#283039]'
                }`}
              >
                Chat
              </Link>
              
              <Link 
                to="/autochatbot" 
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive('/autochatbot') 
                    ? 'bg-primary/10 text-primary' 
                    : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#283039]'
                }`}
              >
                Chatbot
              </Link>

              {/* Planes */}
              <div className="h-6 w-px bg-gray-200 dark:bg-[#283039] mx-2"></div>
              
              <Link 
                to="/pricing" 
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive('/pricing') 
                    ? 'bg-primary/10 text-primary' 
                    : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#283039]'
                }`}
              >
                Planes
              </Link>

              {/* Admin */}
              {isAdmin && (
                <div className="relative group">
                  <button className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    location.pathname.startsWith('/admin')
                      ? 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400' 
                      : 'text-purple-600 dark:text-purple-400 hover:bg-purple-50 dark:hover:bg-purple-900/20'
                  }`}>
                    Admin
                  </button>
                  <div className="absolute right-0 top-full mt-1 w-48 bg-white dark:bg-[#1a2530] rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
                    <Link to="/admin/stats" className="block px-4 py-2.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-[#283039] rounded-t-lg" onClick={() => setMobileMenuOpen(false)}>
                      Analytics
                    </Link>
                    <Link to="/admin/invitations" className="block px-4 py-2.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-[#283039]" onClick={() => setMobileMenuOpen(false)}>
                      Invitaciones
                    </Link>
                    <Link to="/admin/testimonials" className="block px-4 py-2.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-[#283039]" onClick={() => setMobileMenuOpen(false)}>
                      Testimonios
                    </Link>
                    <Link to="/admin/discounts" className="block px-4 py-2.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-[#283039] rounded-b-lg" onClick={() => setMobileMenuOpen(false)}>
                      Descuentos
                    </Link>
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              <Link 
                to="/pricing" 
                className="px-4 py-2 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#283039] transition-colors"
              >
                Planes
              </Link>
              <Link 
                to="/qr-info" 
                className="px-4 py-2 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#283039] transition-colors"
              >
                Info
              </Link>
              <Link 
                to="/contact" 
                className="px-4 py-2 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#283039] transition-colors"
              >
                Contacto
              </Link>
            </>
          )}
        </nav>

        {/* Right Section */}
        <div className="flex items-center gap-3">
          {isAuthenticated ? (
            <>
              {/* Credits Badge */}
              <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 bg-gray-100 dark:bg-[#283039] rounded-lg">
                <span className="text-xs text-gray-500 dark:text-gray-400">Créditos</span>
                <span className="text-sm font-bold text-primary">
                  {user?.credits?.toLocaleString() || '0'}
                </span>
              </div>
              
              {/* User Menu */}
              <div className="flex items-center gap-2">
                <span className="hidden sm:inline text-sm text-gray-600 dark:text-gray-300 font-medium">
                  {user?.name?.split(' ')[0]}
                </span>
                <button
                  onClick={handleLogout}
                  className="px-4 py-2 text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-red-500 transition-colors"
                >
                  Salir
                </button>
              </div>
            </>
          ) : (
            <div className="flex items-center gap-2">
              <Link
                to="/login"
                className="px-4 py-2 text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-primary transition-colors"
              >
                Iniciar sesión
              </Link>
              <Link
                to="/register"
                className="px-5 py-2 bg-primary text-white text-sm font-semibold rounded-lg hover:bg-primary/90 transition-colors"
              >
                Registrarse
              </Link>
            </div>
          )}

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#283039] rounded-lg"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-gray-100 dark:border-[#283039] bg-white dark:bg-background-dark">
          <nav className="p-4 space-y-1">
            {isAuthenticated ? (
              <>
                <Link to="/dashboard" className="block px-4 py-3 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-[#283039]" onClick={() => setMobileMenuOpen(false)}>
                  Dashboard
                </Link>
                <Link to="/generate" className="block px-4 py-3 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-[#283039]" onClick={() => setMobileMenuOpen(false)}>
                  Generar Contenido
                </Link>
                <div className="my-2 border-t border-gray-100 dark:border-[#283039]"></div>
                <Link to="/chat" className="block px-4 py-3 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-[#283039]" onClick={() => setMobileMenuOpen(false)}>
                  Chat IA
                </Link>
                <Link to="/autochatbot" className="block px-4 py-3 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-[#283039]" onClick={() => setMobileMenuOpen(false)}>
                  Chatbot Automatizado
                </Link>
                <div className="my-2 border-t border-gray-100 dark:border-[#283039]"></div>
                <Link to="/pricing" className="block px-4 py-3 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-[#283039]" onClick={() => setMobileMenuOpen(false)}>
                  Planes
                </Link>
                {isAdmin && (
                  <>
                    <Link to="/admin/stats" className="block px-4 py-3 rounded-lg text-purple-600 dark:text-purple-400 hover:bg-purple-50 dark:hover:bg-purple-900/20" onClick={() => setMobileMenuOpen(false)}>
                      Admin Analytics
                    </Link>
                    <Link to="/admin/invitations" className="block px-4 py-3 rounded-lg text-purple-600 dark:text-purple-400 hover:bg-purple-50 dark:hover:bg-purple-900/20" onClick={() => setMobileMenuOpen(false)}>
                      Admin Invitaciones
                    </Link>
                    <Link to="/admin/testimonials" className="block px-4 py-3 rounded-lg text-purple-600 dark:text-purple-400 hover:bg-purple-50 dark:hover:bg-purple-900/20" onClick={() => setMobileMenuOpen(false)}>
                      Admin Testimonios
                    </Link>
                    <Link to="/admin/discounts" className="block px-4 py-3 rounded-lg text-purple-600 dark:text-purple-400 hover:bg-purple-50 dark:hover:bg-purple-900/20" onClick={() => setMobileMenuOpen(false)}>
                      Admin Descuentos
                    </Link>
                  </>
                )}
              </>
            ) : (
              <>
                <Link to="/pricing" className="block px-4 py-3 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-[#283039]" onClick={() => setMobileMenuOpen(false)}>
                  Planes
                </Link>
                <Link to="/qr-info" className="block px-4 py-3 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-[#283039]" onClick={() => setMobileMenuOpen(false)}>
                  Info
                </Link>
                <Link to="/contact" className="block px-4 py-3 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-[#283039]" onClick={() => setMobileMenuOpen(false)}>
                  Contacto
                </Link>
              </>
            )}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
